/**
 * @file 带图的卡片
 * @author 
 *
 */


 import React, {useCallback, useEffect, useMemo, useRef} from 'react';
 import classNames from 'classnames';
 import IntersetBanner from './intersetbanner';
 import {IPictureTextCardItem} from './types.d';
 import startToScroll, {IStartToScrollReturn} from '../../../../utils/scroll-element';
 import useElementInView from '../../../../utils/use-element-in-view';
 
 interface IProps {
     className?: string;
     list?: IPictureTextCardItem[];
 }
 
 const IntersetBannerGroup: React.FC<IProps> = React.memo(props => {
     const className = props.className;
     const list = useMemo(() => {
         return props.list || [];
     }, [props.list]);
 
     const scrollEleRef = useRef<HTMLDivElement>(null);
 
     const scrollHandle = useRef<IStartToScrollReturn>();
 
     const prevMouseEnter = useCallback(() => {
         if (scrollEleRef.current) {
             const ele = scrollEleRef.current;
             scrollHandle.current?.stop();
             scrollHandle.current = startToScroll(ele, 'left', 840 / 1000);
         }
     }, []);
 
     const prevMouseOut = useCallback(() => {
         scrollHandle.current?.stop();
     }, []);
 
     const nextMouseEnter = useCallback(() => {
         if (scrollEleRef.current) {
             const ele = scrollEleRef.current;
             scrollHandle.current?.stop();
             scrollHandle.current = startToScroll(ele, 'right', 840 / 1000);
         }
     }, []);
 
     const nextMouseOut = useCallback(() => {
         scrollHandle.current?.stop();
     }, []);
 
     const isInView = useElementInView(scrollEleRef);
     useEffect(() => {
         if (scrollEleRef.current) {
             const ele = scrollEleRef.current;
             if (isInView) {
                 scrollHandle.current?.stop();
                 scrollHandle.current = startToScroll(ele, 'right');
             }
             else {
                 scrollHandle.current?.stop();
             }
         }
     }, [isInView, list]);
 
     const wrapMouseEnter = useCallback(() => {
         scrollHandle.current?.stop();
     }, []);
 
     return (
         <div
             className={classNames(
                 'paddle-ppdeng-card-group-wrap',
                 className
             )}
             onMouseEnter={wrapMouseEnter}
         >
             <div className="paddle-ppdeng-card-prev"
                  onMouseEnter={prevMouseEnter}
                  onMouseOut={prevMouseOut}
             />
             <div className="paddle-ppdeng-card-next"
                  onMouseEnter={nextMouseEnter}
                  onMouseOut={nextMouseOut}
             />
             <div
                 className="paddle-ppdeng-card-group clear-both"
                 ref={scrollEleRef}
             >
                 <div className="paddle-ppdeng-card-inner">
                     {list.map(item => (
                         <IntersetBanner
                             key={`${item.title},${item.text}`}
                             {...item}
                         />
                     ))}
                 </div>
             </div>
         </div>
     );
 });
 
 export default IntersetBannerGroup;
 